import type {
	CloudLatestImage,
	CloudLatestImageData,
	CloudLatestImageType,
} from 'src/components/Camera/types/cloud-recordings';
import { writable, get } from 'svelte/store';

function create_camera_previews() {
	const { subscribe, set, update } = writable<CloudLatestImageData>({});

	return {
		subscribe,
		set,
		update,
		clear: () => set({}),
		updateDevicePreview: (deviceId: string, previewData: CloudLatestImage) => {
			update((currentPreviews) => {
				return {
					...currentPreviews,
					[deviceId]: previewData,
				};
			});
		},
		getCameraPreview: (deviceId: string, type: CloudLatestImageType) => {
			const preview = get(camera_previews)?.[deviceId]?.[type];
			return preview || null;
		},
	};
}

export const camera_previews = create_camera_previews();
